import styled from 'styled-components';
import img from '../../assets/backgroundImages/Background.png';

export const Container = styled.div<{theme?: any}>`
  width: 100%;
  height: 100vh;
  display: flex;
  background-color: #008ACD;
  background-image: url(${img});
  background-size: contain;
  background-repeat: no-repeat;
  background-origin: content-box;
  background-position-y: 12vh;
  text-align: center;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 3vh;
  padding-bottom: 4vh;
  padding-left: 5vw;
  padding-right: 5vw;
`

export const TopContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1vh;
  margin-bottom: 2vh;
`
